import { USER_LOGGED_IN } from '../actions';
import isEmpty from 'lodash/isEmpty';

const initialState = {
  isAuthenticated: false,
  user: {}
};

export default function login(state = initialState, action = {}) {
  switch(action.type) {
    case USER_LOGGED_IN:
      return {
        isAuthenticated: !isEmpty(action.user),
        user: action.user
      };
    default: return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/login.js